import { questionsByTopicId } from '@/data/questions';
import type { Question } from '@/models/question';
import type { PositionsMode } from '@/models/position';

function getTargetQuestionCount(mode: PositionsMode): number {
  return mode === 'complete' ? 24 : 8;
}

export function buildQuestionPlan(mode: PositionsMode, selectedTopicIds: string[]): Question[] {
  if (!mode || selectedTopicIds.length === 0) {
    return [];
  }

  const selectedBanks = selectedTopicIds
    .map((topicId) => ({ topicId, questions: questionsByTopicId[topicId] ?? [] }))
    .filter((entry) => entry.questions.length > 0);

  if (selectedBanks.length === 0) {
    return [];
  }

  const targetCount = getTargetQuestionCount(mode);
  const questionOffsets = new Map<string, number>();
  const plan: Question[] = [];

  for (let index = 0; index < targetCount; index += 1) {
    const bank = selectedBanks[index % selectedBanks.length]!;
    const offset = questionOffsets.get(bank.topicId) ?? 0;
    const template = bank.questions[offset % bank.questions.length]!;

    questionOffsets.set(bank.topicId, offset + 1);

    plan.push({
      ...template,
      id: `${template.id}-${offset + 1}`,
    });
  }

  return plan;
}
